var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationTypeWrapper',{attrs:{"notification":_vm.notification}},[_c('p',{staticClass:"my-0"},[_vm._v("\n    A new\n    "),_c('a',{attrs:{"href":_vm.actionLink},domProps:{"textContent":_vm._s(`blog entry`)}}),_vm._v(" "),_c('strong',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" has been published.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }